import React from 'react';

import UserSignin from './signin';
import UserSignout from './signout';
import UserCode from './code';
import UserAccount, {
  AccountOrderStatus
} from './account';
import UserAccountStatus from './account_status';
import UserPayments from './payments';

import './style.less';

export default class User extends React.Component {
  render() {
    return (<div className="user-component">{this.props.children}</div>);
  }
}

let UserAccountOrderStatus = AccountOrderStatus;

export {
  UserSignin,
  UserSignout,
  UserCode,
  UserAccount,
  UserAccountOrderStatus,
  UserAccountStatus,
  UserPayments
};



/** WEBPACK FOOTER **
 ** ./src/views/user/index.js
 **/